export const VIEW_COMPONENT = Symbol('audit-log:view-component');

export const PROPERTY_INFO = Symbol('reflection:property-info');